/* eslint-disable linebreak-style */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {
  CoreService,
  IResponse
} from 'src/app/@amiga-pyme/services/core.service';
import { lastValueFrom } from 'rxjs';

export const ROUTE_LOGIN = '/auth/logout';
@Injectable({
  providedIn: 'root'
})
export class LogoutService extends CoreService {
  constructor(http: HttpClient) {
    super(http);
  }
  async logout(): Promise<IResponse> {
    const response = await lastValueFrom(
      this.request({ method: 'POST', url: ROUTE_LOGIN })
    );
    return {
      message: response.body.message,
      data: response.body.data,
      status: response.status
    };
  }
}
